module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/new_logo-8e956cade7786eec155d7d4f64759273.png";